import React from 'react'
import AdminVehicleEdit from '../../components/admin/vehicles/admin-vehicle-edit'
import AdminTemplate from '../../templates/admin-template'


const AdminVehiclesEditPage = () => {
  return (
    <AdminTemplate>
        <AdminVehicleEdit/>
    </AdminTemplate>
  )
}

export default AdminVehiclesEditPage